import { siteStats, tickerItems } from '@/mocks/site';

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20collage%20with%20glowing%20stage%20spotlight%20beams%2C%20crimson%20and%20amber%20cinematic%20haze%2C%20scattered%20newspaper%20texture%2C%20dramatic%20moody%20atmosphere%2C%20soft%20particles%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=gt-hero-01&orientation=landscape"
          alt="瓜田情报局首屏背景：舞台灯光与暖色迷雾交织的热点追踪氛围"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/25 to-black/35" />
      </div>

      <div className="relative z-10 mx-auto flex min-h-[92vh] w-full max-w-6xl flex-col justify-center px-4 pb-24 pt-32 md:px-6">
        <div className="w-full text-center">
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur">
            <span className="flex h-3 w-3 items-center justify-center">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-400 animate-soft-pulse" />
            </span>
            正在持续更新 · 最新一条 3 分钟前
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl lg:text-6xl">
            黑料大瓜后续进展
            <span className="mt-2 block text-accent-300">全程追踪，一个都不遗漏</span>
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
            最新回应、剧情反转、当事人发声、第二弹持续更新。从爆料爆出到尘埃落定，我们把碎片整理成时间线，
            蹲后续的吃瓜群众直接看这里就够了。
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#live"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-flashlight-line" />
              看实时追踪
            </a>
            <a
              href="#timeline"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/30 bg-white/10 px-7 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-white/20 sm:w-auto"
            >
              <i className="ri-git-commit-line" />
              看瓜情时间线
            </a>
          </div>
        </div>

        <div className="mt-14 grid w-full grid-cols-2 gap-3 rounded-lg border border-white/15 bg-white/10 p-4 backdrop-blur md:grid-cols-4 md:gap-5 md:p-6">
          {siteStats.map((item) => (
            <div key={item.label} className="text-center md:text-left">
              <p className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{item.value}</p>
              <p className="mt-1 text-xs text-background-200 md:text-sm">{item.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10 flex items-center gap-3 bg-primary-500/95 px-4 py-2.5 md:px-8">
        <span className="flex flex-shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-bold text-background-50">
          <i className="ri-flashlight-fill" />
          快讯滚播
        </span>
        <div className="flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-10">
            {[...tickerItems, ...tickerItems].map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex items-center gap-2 whitespace-nowrap text-xs text-background-100"
              >
                <span className="h-1 w-1 rounded-full bg-accent-300" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}